<template>
  <a v-if="btn" href="javascript:void(0);" :class="classes">
    <slot />
  </a>
  <span v-else :class="classes">
    <slot />
  </span>

</template>



<script>



export default {
  props: {
    icon: {
      type: String,
      required: true,
    },
    btn: {
      type: [Boolean],
      default: false,
    },
  },



  computed: {
    classes() {
      return {
        'dn-icon': true,
        'dn-icon--btn': this.btn,
        [`dn-icon-${this.icon}`]: true,
      }
    },
  },
}
</script>


// WEBPACK FOOTER //
// Icon.vue?435ca16e